<template>
  <NuxtLayout>
    <div class="app_container_box">
      <div class="app_container">
        <div class="app_container_top w">
          <div class="title_box">
            <img
              src="@/assets/pc/mini-title4.png"
              alt=""
            >
            <span>百校联盟·无界共赢</span>
          </div>
          <div
            v-loading="ctrl.loading1"
            class="block"
          >
            <el-carousel
              v-if="map.advList.length > 0"
              height="340px"
              arrow="never"
              class="carousel"
            >
              <el-carousel-item
                v-for="(i, index) in map.advList"
                :key="index"
              >
                <custom-link
                  :to="handleNavigate(i)"
                  :target-type="i.targetType"
                >
                  <img
                    class="article_img"
                    :src="i.imageUrl"
                    :alt="i.advName"
                  >
                </custom-link>
              </el-carousel-item>
            </el-carousel>
            <div class="hot">
              <p class="recommend">
                热门推荐
                <img
                  src="@/assets/pc/icon_fire.png"
                  alt=""
                  srcset=""
                >
              </p>
              <template v-if="map.hotList.length > 0">
                <div
                  v-for="(i, index) in map.hotList"
                  :key="index"
                  class="item"
                  @click="viewDetail(i.id)"
                >
                  <p class="title">
                    {{ i.title }}
                  </p>
                  <p class="c_999 tx-ov flex-item">
                    <span>{{ i.readCount }}人已浏览</span>
                    <span>{{ i.gmtCreate.split(' ')[0] }}</span>
                  </p>
                </div>
                <!-- <div class="item">
                  <p class="title">
                    新疆伊犁州直职业院校名师名匠培育及“双师型”教师专题研修班赴京东产教融合基地考察研修
                  </p>
                  <p class="c_999 tx-ov flex-item">
                    <span>15人已浏览</span>
                    <span>2023-08-18</span>
                  </p>
                </div>
                <div class="item">
                  <p class="title">
                    新疆伊犁州直职业院校名师名匠培育及“双师型”教师专题研修班赴京东产教融合基地考察研修
                  </p>
                  <p class="c_999 tx-ov flex-item">
                    <span>15人已浏览</span>
                    <span>2023-08-18</span>
                  </p>
                </div>
                <div class="item">
                  <p class="title">
                    新疆伊犁州直职业院校名师名匠培育及“双师型”教师专题研修班赴京东产教融合基地考察研修
                  </p>
                  <p class="c_999 tx-ov flex-item">
                    <span>15人已浏览</span>
                    <span>2023-08-18</span>
                  </p>
                </div> -->
              </template>
              <div
                v-else
                class="no_data"
              >
                暂无数据
              </div>
            </div>
          </div>
        </div>
        <div class="app_container_type">
          <div class="w">
            <teacher-category-list
              :list="map.categorys"
              name="categoryName"
              :style="2"
              :default-id="map.categoryId"
              @change="changeCategory"
            />
          </div>
        </div>
        <div class="app_container_bottom w">
          <div v-loading="ctrl.loading2">
            <article-list :list="map.articleList" />
          </div>
          <div
            v-if="page.totalPage > 1"
            class="pagination"
          >
            <el-pagination
              v-model:currentPage="page.pageCurrent"
              v-model:pageSize="page.pageSize"
              background
              layout="total, prev, pager, next, jumper"
              :total="page.totalCount"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
import { articleCategory, articleAdvList, articleHot, articlePage } from '../../api/article.js'
import { onMounted, nextTick } from 'vue'
import cookie from '@/utils/cookies'
import { teacherPage, teacherRankList } from '../../api/teacher'
import { parseTime } from '@/utils/index.js'

const cookieData = cookie.getShop()
useHead({
  title: computed(() => `资讯中心-${cookieData.shopName}`),
  meta: [{
    hid: 'keywords',
    name: 'keywords',
    content: '资讯中心'
  },
  {
    hid: 'description',
    name: 'description',
    content: '资讯中心'
  }]
})
const route = useRoute()
const map = reactive({
  advList: [],
  categorys: [],
  categoryId: route.query.categoryId || '',
  hotList: [],
  articleList: []
})
const page = reactive({
  totalCount: 0,
  pageCurrent: 1,
  // pageSize: 20,
  pageSize: 4,
  totalPage: 1
})
const ctrl = reactive({
  loading1: false,
  loading2: false
})
const router = useRouter()
const changeCategory = (id) => {
  const query = route.query
  router.push({
    query: Object.assign({ ...query }, { categoryId: id },
      () => { })
  })
  map.categoryId = id
  getArticleList()
}

const viewDetail = (id) => {
  router.push({
    path: '/article/view',
    query: {
      id
    }
  })
}
const handleCurrentChange = (v) => {
  page.pageCurrent = v
  document.querySelector('#app').scrollTop = 0
  getArticleList()
}
const getArticleList = () => {
  ctrl.loading2 = true
  articlePage({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    categoryId: map.categoryId
  }).then(res => {
    if (res) {
      map.articleList = res.list || []
      page.pageCurrent = res.pageCurrent
      page.totalCount = res.totalCount
      page.totalPage = res.totalPage
    }
    ctrl.loading2 = false
  })
}
const getAdvList = () => {
  ctrl.loading1 = true
  articleAdvList().then(res => {
    if (res) {
      if (res.length === 0) {
        map.advList = [
          {
            imageUrl: 'https://static.roncoos.com/edu/pc/carousel.png',
            targetType: 99,
            advName: ''
          }
        ]
      } else {
        map.advList = res
      }
    }
    ctrl.loading1 = false
  })
}
const nowDay = new Date().getTime()
const beginTime = parseTime(nowDay - 30 * 24 * 60 * 60 * 1000)
const getHotList = () => {
  ctrl.loading1 = true
  articleHot({ size: 10, beginTime }).then(res => {
    map.hotList = res || []
    ctrl.loading1 = false
  })
}
const { data, pending, error } = await useAsyncData('ArticleListPage', () => {
  return new Promise(async (resolve) => {
    if (route.query) {
      map.categoryId = route.query.categoryId
    }
    Promise.allSettled([
      articleAdvList(),
      articleCategory(),
      articleHot({ size: 10, beginTime }),
      articlePage({
        pageCurrent: page.pageCurrent,
        pageSize: page.pageSize,
        categoryId: map.categoryId
      })
    ]).then(([adList, category, hotList, article]) => {
      const data = {}
      if (adList.status === 'fulfilled') {
        data.adList = adList.value
      } else {
        data.adList = {}
      }
      if (category.status === 'fulfilled') {
        data.category = category.value
      } else {
        data.category = []
      }
      if (hotList.status === 'fulfilled') {
        data.hotList = hotList.value
      } else {
        data.hotList = []
      }
      if (article.status === 'fulfilled') {
        data.article = article.value
      } else {
        data.article = []
      }
      resolve(data)
    })
  })
}, { initialCache: false })

if (!pending.value && data.value) {
  const d = data.value
  if (d.adList.length === 0) {
    map.advList = [
      {
        imageUrl: 'https://static.roncoos.com/edu/pc/carousel.png',
        targetType: 99,
        advName: ''
      }
    ]
  } else {
    map.advList = d.adList
  }
  map.categorys = d.category.concat([])
  map.categorys.unshift({
    categoryName: '全部',
    id: ''
  })
  map.hotList = d.hotList || []
  map.articleList = d.article.list || []
  page.pageCurrent = d.article.pageCurrent
  page.totalCount = d.article.totalCount
  page.totalPage = d.article.totalPage
}

</script>
<style lang="scss">
.carousel {
  width: 860px;
  border-radius: 12px;
  overflow: hidden;

  .article_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .el-carousel__indicators {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    bottom: 20px;
    padding: 0px 12px;
    padding-right: 6px;
    padding-bottom: 4px;
  }

  .el-carousel__button {
    width: 9px;
    height: 6px;
    border-radius: 15px;
    margin-right: 7px;
  }

  .is-active {
    .el-carousel__button {
      width: 15px;
    }
  }

  .el-carousel__indicator--horizontal {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.app_container_box {
  width: 100%;
  background-color: #fff;
}

.app_container_type {
  width: 100%;
  background-color: rgb(245, 247, 250);
  box-shadow: 0px 0px 8px #ccc;
}

.title_box {
  width: 100%;
  padding-top: 26px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;

  img {
    width: 180px;
  }

  span {
    font-size: 14px;
    color: #333;
    margin-left: 40px;
  }
}

.content_page {
  width: 1200px;
  margin: 20px auto;
}

.block {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.hot {
  width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .recommend {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 16px;
    position: relative;

    img {
      position: absolute;
      height: 24px;
      left: 28%;
      top: -5px;
      z-index: 999;
    }
  }

  .no_data {
    color: #999;
    text-align: center;
    line-height: 353px;
  }

  .item {
    padding: 4px 10px;
    box-sizing: border-box;
    margin-bottom: 12px;
    cursor: pointer;
    background-color: rgb(245, 247, 250);
    border-radius: 8px;
    box-shadow: 0px 4px 6px #ccc;

    .title {
      width: 100%;
      font-size: 16px;
      line-height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      color: #333;
      margin-bottom: 6px;
    }

    .flex-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #888;
    }

    &:last-child {
      margin-bottom: 0px;
    }

    &:hover p {
      color: #2256F6;
    }
  }
}

.pagination {
  text-align: center;
}</style>
